import React from 'react';

import { Divider, ListItem, IconMenu, MenuItem, IconButton } from 'material-ui';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import { grey400 } from 'material-ui/styles/colors';

const iconButtonElement = (<IconButton touch={true}><MoreVertIcon color={grey400} /></IconButton>);

const rightIconMenu = (up, down, toggle, del) => (
    <IconMenu iconButtonElement={iconButtonElement}>
        <MenuItem onClick={up}>Move up</MenuItem>
        <MenuItem onClick={down}>Move down</MenuItem>
        <MenuItem onClick={toggle}>Toggle stop</MenuItem>
        <Divider />
        <MenuItem onClick={del}>Delete</MenuItem>
    </IconMenu>
);

const InternalItem = ({ renderAvatar, getLegInfo, subtitle, showEditDialog, menu, d, i }) => (
    <ListItem
        key={d.id}
        leftAvatar={renderAvatar(d.name)}
        primaryText={d.name}
        secondaryText={subtitle && getLegInfo(i)}
        onClick={() => showEditDialog(d)}
        rightIconButton={rightIconMenu(
            () => menu.moveUp(d),
            () => menu.moveDown(d),
            () => menu.toggleStop(d),
            () => menu.remove(d)
        )}
    />
);

const DestinationListItem = ({ ...rest }) => (
    <React.Fragment>
        {rest.d.sleep && <InternalItem subtitle={false} {...rest} />}
        {rest.d.sleep && <Divider />}
        <InternalItem subtitle={true} {...rest} />
    </React.Fragment>
);

export default DestinationListItem;


// WEBPACK FOOTER //
// ./src/components/DestinationListItem.js